<template>
  <div class="upload-big-file">
    <div class="con-input-upload" ref="upload-dropzone">
      <div class="upload-big-file-text" v-if="!isUploading">
        {{ fileData && fileData.status === 'canceled' ? 'Upload cancelled' : fileData && fileData.status === 'error' ? "Upload failed" : fileData && fileData.status === 'success' ? 'File uploaded' : title }}
      </div>
      <div class="upload-big-file-progress-wrapper" v-if="isUploading">
        <div class="upload-big-file-progress" :style="{width: uploadedAmount + '%'}"></div>
        <div class="upload-big-file-progress-percent">
          {{ uploadedAmount + '%' }}
        </div>
      </div>
      <div class="upload-big-file-block">
        <i translate="translate" class="material-icons notranslate">cloud_upload</i>
      </div>
    </div>
    <div class="upload-big-file-block uploading" v-if="isUploading">
      <CustomSvg icon="play" class="upload-big-file-icon" color="#7367f0" @click.native="resume" v-if="isPaused" />
      <CustomSvg icon="pause" class="upload-big-file-icon" color="#7367f0" @click.native="pause" v-if="!isPaused" />
      <CustomSvg icon="stop" class="upload-big-file-icon"  color="#7367f0" @click.native="cancel" />
    </div>
  </div>
</template>

<script>

import Resumable from 'resumablejs'
import CustomSvg from './CustomSvg.vue'

export default {
  components: {
    Resumable,
    CustomSvg
  },
  props: {
    updateAsset: {
      type: Function,
      required: false,
    },
    title: {
      type: String,
      default: 'Upload File'
    },
    type: {
      type: String
    },
    fileType: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      resumable: null,
      fileData: null,
      files: [],
      isPaused: false
    }
  },
  mounted() {
    this.initUploader();
  },
  destroyed() {
    if (this.fileData && this.fileData.file && this.fileData.status !== 'success') {
      this.cancel();
    }
  },
  methods: {
    initUploader() {
      this.resumable = new Resumable({
        target:`${this.$store.state.appUrl}/upload-file`,
        chunkSize: this.$store.state.resumableUploadChunkSize,
        simultaneousUploads: 4,
        throttleProgressCallbacks: 1,
        setChunkTypeFromFile: true,
        prioritizeFirstAndLastChunk: false,
        testChunks: false,
        fileType: this.fileType,
        permanentErrors: [],
        query: {
          Authorization: 'Bearer ' + localStorage.getItem('jwt')
        }
      });

      // Resumable.js isn't supported, fall back on a different method
      if (!this.resumable.support) {
        this.$emit('abort');
      } else {
        this.resumable.assignBrowse(this.$refs['upload-dropzone']);
        this.resumable.assignDrop(this.$refs['upload-dropzone']);
        this.resumable.on('fileAdded', (file, event) => {
          file.hasUploaded = false;
          this.isPaused = false;
          const rndId = Math.random().toString(36).substring(3);
          file.fileName = `${rndId}_${file.fileName.replace(/\s|[^a-z0-9.]/gi, "_")}`
          // keep a list of file with some extra data that we can use as props
          this.fileData = {
            file,
            status: 'uploading',
            progress: 0,
          };

          // this.$axios.post('/create-multipart-upload', {
          //   filename: file.fileName,
          //   contentType: file.file.type
          // }).then(({data: uploadId}) => {
          //   file.uniqueIdentifier = uploadId;
          //   this.resumable.upload();
          // }).catch(e => {
          //   console.log(1, e)
          // })

          this.resumable.upload();
        })
        this.resumable.on('fileSuccess', (file, res) => {
          // this.$axios.post('/finish-multipart-upload', {
          //   filename: file.fileName,
          // }).then(({data: completedUpload}) => {
          //   this.$emit('addUploadedFile', {data: completedUpload,  type: this.type});
          //   this.fileData.status = 'success';
          //   this.resumable.removeFile(this.fileData.file);
          //   this.$vs.notifyWrapper({color: 'success', fixed: true, title: 'File was uploaded'})
          // }).catch(err => {
          //   console.log("finish-multipart-upload ERROR", err.message || err)
          // })
          this.$emit('addUploadedFile', {data: JSON.parse(res),  type: this.type});
          this.fileData.status = 'success';
          this.resumable.removeFile(this.fileData.file);
          this.$vs.notifyWrapper({color: 'success', fixed: true, title: 'File was uploaded'})
        })
        this.resumable.on('fileError', (file, event) => {
          this.fileData.status = 'error'
          this.resumable.removeFile(this.fileData.file);
          this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Upload failed'})
        })
        this.resumable.on('fileRetry', (file, event) => {
          this.fileData.status = 'retrying'
        })
        this.resumable.on('fileProgress', (file) => {
          // if we are doing multiple chunks we may get a lower progress number if one chunk response comes back early
          let progress = file.progress()
          if(progress > this.fileData.progress) {
            this.fileData.progress = progress
          }
        })
      }
    },
    findFile(file){
      let f = this.files.find(item => item.file.uniqueIdentifier === file.uniqueIdentifier && item.status !== 'canceled');
      return f ? f : {}
    },
    upload(){
      this.fileData.file.resumableObj.upload()
      this.isPaused = false
    },
    pause(){
      this.fileData.file.pause();
      this.isPaused = true;
    },
    resume(){
      this.pause(); // not sure why, but we have to call pause again before upload will resume
      this.upload();
    },
    cancel(){
      this.fileData.file.cancel();
      this.fileData.status = 'canceled';
      this.fileData.progress = 0;
      this.isPaused = false;
      if (this.fileData.file.fileName) {
        // this.cancelFile();
      }
      this.resumable.removeFile(this.fileData.file);
      this.$vs.notifyWrapper({color: 'danger', fixed: true, title: 'Upload file was cancelled'})
    },
    cancelFile() {
      this.$axios.post('/cancel-large-file-new', {
        filename: this.fileData.file.fileName
      }).catch(e => {
        console.log(1, e)
      })
    }
  },
  watch: {
    fileType: function (props, oldProps) {
      if (JSON.stringify(props) !== JSON.stringify(oldProps)) {
        this.initUploader();
      }
    }
  },
  computed: {
    isUploading(){
      return (this.fileData && this.fileData.status !=='success' && this.fileData.status !== 'canceled' && this.fileData.status !== 'error')
    },
    uploadedAmount(){
      return this.fileData ? this.fileData.progress === 100 ? this.fileData.progress : (this.fileData.progress * 100).toFixed(2) : 0
    },
  },
}
</script>
<style>

</style>
